import classNames from 'classnames';
import React from 'react';
import { Transition, TransitionGroup } from 'react-transition-group';
import useAppSelector, { useAppDispatch } from '../app/redux/useAppSelector';
import UIActions from '../ui/UIActions';
import Toast from './Toast';
import styles from './ToastContainer.module.scss';

const ToastContainer = () => {
  const dispatch = useAppDispatch();
  const toasts = useAppSelector((state) => state.ui.toasts);

  return (
    <TransitionGroup className={`${styles.toastContainer}`}>
      {toasts
        .slice()
        .reverse()
        .map(({ id, render }) => (
          <Transition key={id} timeout={500}>
            {(state) => {
              const onDismiss = () => dispatch(UIActions.removeToast(id));

              return (
                <div className={classNames(styles.toastOuter, styles[state])}>
                  {typeof render === 'function' ? (
                    render({ onDismiss })
                  ) : (
                    <Toast onDismiss={onDismiss} {...render} />
                  )}
                </div>
              );
            }}
          </Transition>
        ))}
    </TransitionGroup>
  );
};

export default ToastContainer;
